'use client';

import React, { useState } from 'react';
import { ThemeProvider } from 'next-themes';

import { PrivyProvider } from '@privy-io/react-auth';
import { WagmiProvider } from '@privy-io/wagmi';
import MotionProvider from '@shaojiang/components/MotionProvider';
import { wagmiConfig } from '@shaojiang/config/wagmi';
import { Toaster } from '@shaojiang/lib/toaster';
import { DEFAULT_THEME_MODE } from '@shaojiang/theme/modes';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

export default function Providers({ children }: { children: React.ReactNode }) {
  // One client per browser session, never shared between server requests
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: { queries: { staleTime: 60_000, refetchOnWindowFocus: false } },
      }),
  );

  return (
    <PrivyProvider
      appId={process.env.NEXT_PUBLIC_PRIVY_APP_ID || ''}
      clientId={process.env.NEXT_PUBLIC_PRIVY_CLIENT_ID || ''}
      config={{
        // Create embedded wallets for users who don't have a wallet
        embeddedWallets: {
          ethereum: {
            createOnLogin: 'users-without-wallets',
          },
        },
      }}
    >
      <QueryClientProvider client={queryClient}>
        <WagmiProvider config={wagmiConfig}>
          <ThemeProvider defaultTheme={DEFAULT_THEME_MODE} attribute='class'>
            <MotionProvider>
              {children}
              <Toaster />
            </MotionProvider>
          </ThemeProvider>
        </WagmiProvider>
      </QueryClientProvider>
    </PrivyProvider>
  );
}
